import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

import { AuthProvider } from '../api/Auth';

// 导入页面组件
import Promotion from '../pages/Promotion'
import HomePage from '../pages/HomePage';
import Dashboard from '../pages/admin/Dashboard';
import Appearance from '../pages/admin/Appearance';
import LinksManager from '../pages/admin/LinksManager';
import StoresManager from '../pages/admin/StoreManager';
import Subscription from '../pages/admin/Subscription';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import DymanicOverlay from '../pages/DymanicOverlay';
import ChangePassword from '../pages/auth/ChangePassword';
import SetPassword from '../pages/auth/SetPassword';
import ForgotPassword from '../pages/auth/ForgotPassword';
import GoogleReviewLinkGenerator from '../pages/GoogleReviewLinkGenerator';
import Pricing from '../pages/Pricing';
import Contact from '../pages/Contact';

const AppRouter: React.FC = () => {
  // 这里可以从状态管理或上下文中获取认证状态

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/logout" element={<Login />} />
          <Route path="/change_pass" element={<ChangePassword />} />
          <Route path="/forgot_pass" element={<ForgotPassword />} />
          <Route path="/set_pass" element={<SetPassword />} />

          <Route path="/promotion" element={<Promotion />} />
          <Route
            path="/google-review-link-generator"
            element={<GoogleReviewLinkGenerator />}
          />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact-us" element={<Contact />} />

          <Route path="/:username/:linkPath?" element={<DymanicOverlay />} />
          <Route path="/@:username/:linkPath?" element={<DymanicOverlay />} />
          <Route path="/link/:username/:linkPath?" element={<DymanicOverlay />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/appearance"
            element={
              <ProtectedRoute>
                <Appearance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/links"
            element={
              <ProtectedRoute>
                <LinksManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/stores"
            element={
              <ProtectedRoute>
                <StoresManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/subscription"
            element={
              <ProtectedRoute>
                <Subscription />
              </ProtectedRoute>
            }
          />

          {/* 404 页面 - 重定向到首页 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppRouter; 